import { managePartnerTabRoutes } from '@atlassian/mpac-utils';
export const TabNames = {
  APPS: 'Apps',
  DETAILS: 'Details',
  CONTACTS: 'Contacts',
  PROMOTIONS: 'Promotions',
  SECURITY: 'Security',
  REPORTS: 'Reports',
  ADMIN: 'Admin',
  PAYMENT_INFO: 'Payment'
};
export const getTabs = (partnerId, permissions, managePartnerSpaTabs) => {
  const links = managePartnerTabRoutes();
  return [{
    href: links.apps.expand({
      partnerId
    }),
    text: TabNames.APPS,
    renderSPARoute: managePartnerSpaTabs.includes(TabNames.APPS)
  }, {
    href: links.details.expand({
      partnerId
    }),
    text: TabNames.DETAILS,
    renderSPARoute: managePartnerSpaTabs.includes(TabNames.DETAILS)
  }, ...(permissions.canManagePartnerDetails ? [{
    href: links.contacts.expand({
      partnerId
    }),
    text: TabNames.CONTACTS,
    renderSPARoute: managePartnerSpaTabs.includes(TabNames.CONTACTS)
  }] : []), ...(permissions.canManagePartnerPaymentDetails ? [{
    href: links.payment.expand({
      partnerId
    }),
    text: TabNames.PAYMENT_INFO,
    renderSPARoute: managePartnerSpaTabs.includes(TabNames.PAYMENT_INFO)
  }] : []), ...(permissions.canManagePromotions ? [{
    href: links.promotions.expand({
      partnerId
    }),
    text: TabNames.PROMOTIONS,
    renderSPARoute: managePartnerSpaTabs.includes(TabNames.PROMOTIONS)
  }] : []), ...(permissions.canManagePartnerDetails ? [{
    href: links.security.expand({
      partnerId
    }),
    text: TabNames.SECURITY,
    renderSPARoute: managePartnerSpaTabs.includes(TabNames.SECURITY)
  }] : []), ...(permissions.canViewSalesReport ? [{
    href: links.reports.expand({
      partnerId
    }),
    text: TabNames.REPORTS,
    renderSPARoute: managePartnerSpaTabs.includes(TabNames.REPORTS)
  }] : []), ...(permissions.isSiteAdmin ? [{
    href: links.admin.expand({
      partnerId
    }),
    text: TabNames.ADMIN,
    renderSPARoute: managePartnerSpaTabs.includes(TabNames.ADMIN)
  }] : [])];
};